module.exports = __webpack_public_path__ + "static/media/52_B.dc017aa2.png";